import { BUSINESS_DETAILS_FIELD_KEYS, PINCODE_DIGIT_LENGTH } from '../../MandateFormConstants';
import { isValidPincode } from '../../../../utils/utils';

// Whether the `businessDetails.*` slice of formData carries any actual value - an empty
// Business Details section (every field untouched) must not itself force a save. Shared by
// useManageDealDrawer's handleSaveMandateApplicants (save-fires-when-either gate) and the
// save-payload assembly (whether to include `businessDetails` at all).
export const hasBusinessDetailsData = (businessDetails: Record<string, any>): boolean =>
    Object.values(businessDetails || {}).some((value) => value !== '' && value !== null && value !== undefined);

// Business Address Pincode is optional but, when present, must be a well-formed 6-digit pincode -
// shared by BusinessDetailsSection's inline error and isBusinessDetailsValid below so both agree
// on the same rule.
export const isBusinessPincodeValid = (value: any): boolean => isValidPincode(value, PINCODE_DIGIT_LENGTH);

// Whether the whole `businessDetails.*` slice is valid to save - mirrors isApplicantEntryValid's
// shape (a single composed predicate over the section's fields) so useManageDealDrawer's
// validateForm gates on both sections the same way.
export const isBusinessDetailsValid = (businessDetails: Record<string, any>): boolean =>
    isBusinessPincodeValid(businessDetails?.[BUSINESS_DETAILS_FIELD_KEYS.BUSINESS_ADDRESS_PINCODE]);
